import axios from "axios";

var baseDomain = "";

switch(document.location.host)
{
	case "clickandcollect.scanandget-development.co.uk":
		baseDomain = "https://api.scanandget-development.co.uk";
		break;	
	case "clickandcollect.scanandget-staging.co.uk":
		baseDomain = "https://api.scanandget-staging.co.uk";
		break;	
	case "clickandcollect.scanandget.co.uk":
		baseDomain = "https://api.scanandget.co.uk";
		break;	
	case "localhost:8081":
		baseDomain = "http://localhost/clickcollect/public_html";
		break;
}

const baseURL = `${baseDomain}/api`;

export default axios.create({
baseURL
});